/* The builder's non-week states. Centred in the work column, because they replace the whole
 * canvas rather than sitting inside it. */

.notice {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-3);
  align-items: center;
  justify-content: center;
  padding: var(--space-16) var(--gap-screen);
  text-align: center;
}

.title {
  max-width: 46ch;
  font-family: var(--font-head);
  font-size: var(--fs-h2);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-snug);
  letter-spacing: var(--ls-title);
  color: var(--text);
}

.message {
  max-width: 62ch;
  font-size: var(--fs-body);
  line-height: var(--lh-relaxed);
  color: var(--text-2);
}

.action {
  height: var(--h-control);
  padding: var(--space-0) var(--space-14px);
  margin-top: var(--space-1);
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  letter-spacing: var(--ls-heading);
  color: var(--text);
  cursor: pointer;

  /* Flat fill, never a coloured blur — the handoff's "no glow on buttons". A retry is also not
   * the screen's real action, so it stays neutral and spends none of the accent budget. */
  background: transparent;
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--r-button);
}

.action:hover {
  background: var(--hover-tint);
}
